import { render } from "./Servicerequest.vue?vue&type=template&id=507c75b0&scoped=true"
import script from "./Servicerequest.vue?vue&type=script&lang=js"
export * from "./Servicerequest.vue?vue&type=script&lang=js"

import "./Servicerequest.vue?vue&type=style&index=0&id=507c75b0&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507c75b0"]])

export default __exports__